import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createTenantMaintenanceKioskRequest } from 'actions/maintenanceActions';

import { CSSTransitionGroup } from 'react-transition-group';

import { serviceRequestVerbiage } from 'helpers/VerbiageHelper';
import { MdDescription as TicketIcon } from 'react-icons/md';
import RequestMaintenanceKioskDialog from './RequestMaintenanceKioskDialog';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';

const style = {
  row: { height: '100%', textAlign: 'center', padding: '10vh 0 0' },
  ticket_icon: { color: '#eaeaea', height: '30vh', width: '30vh' },
};

let MaintenanceTicketsKiosk = class EventCalendar extends Component {
  state = {
    requestMaintenanceDialogOpen: false,
  };

  toggleDialog = () => {
    this.setState((prevState) => ({
      requestMaintenanceDialogOpen: !prevState.requestMaintenanceDialogOpen,
    }));
  };

  submitForm = (formData) => {
    return this.props.createTenantMaintenanceKioskRequest(formData).then(() => {
      this.toggleDialog();
    });
  };

  render() {
    return (
      <div className="body" role="main">
        <div className="centers">
          <HeaderWithPeriod
            headerText="Tickets"
            actionButtonLabel={`Add ${serviceRequestVerbiage('titlecase')}`}
            toggleDialog={this.toggleDialog}
          />

          <CSSTransitionGroup
            transitionName="fade_out_buttons"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {this._renderGetStarted()}
          </CSSTransitionGroup>

          <RequestMaintenanceKioskDialog
            toggleDialog={this.toggleDialog}
            isOpen={this.state.requestMaintenanceDialogOpen}
            submitForm={this.submitForm}
          />
        </div>
      </div>
    );
  }

  _renderGetStarted = () => {
    return (
      <div className="row" style={style.row}>
        <TicketIcon style={style.ticket_icon} />
        <h4 style={{ fontFamily: 'Circular' }}>
          {' '}
          Click on the top right red button to add a {serviceRequestVerbiage()}.{' '}
        </h4>
      </div>
    );
  };
};

MaintenanceTicketsKiosk = connect(null, { createTenantMaintenanceKioskRequest })(
  MaintenanceTicketsKiosk
);

export default MaintenanceTicketsKiosk;
